
export const keyMap = {
      'newBooking': ['ctrl+`'],
      'quickSave':['ctrl+q'],
      'quickClose':'esc'
    }